import styled from '@emotion/styled'

export const Container = styled.div`
  width: 80%;
  margin: 20px auto;
`

export const Content = styled.div`
  padding: 50px;
`

export const Head = styled.div`
  display: grid;
  grid-template-columns: 30px auto;
  padding-bottom: 30px;
`

export const Body = styled.div`
  padding: 0 30px;
`
